import React from "react";

import PresentationHeader from "components/Headers/PresentationHeader.js";
import FooterBlack from "components/Footers/FooterBlack.js";
import ForgeMethod from "./presentation-sections/ForgeMethod.js";
import TheGap from "./presentation-sections/TheGap.js";
import Debrief from "./presentation-sections/Debrief.js";
import PastProjects from "./presentation-sections/PastProjects.js";
import OurProducts from "./presentation-sections/OurProducts.js";

function Presentation() {
  document.documentElement.classList.remove("nav-open");

  React.useEffect(() => {
    document.body.classList.add("presentation-page");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return () => {
      document.body.classList.remove("presentation-page");
    };
  });

  return (
    <>
      <PresentationHeader />
      <div id="projects">
        <PastProjects />
      </div>
      <OurProducts />
      <ForgeMethod />
      <TheGap />
      <Debrief />
      <FooterBlack />
    </>
  );
}

export default Presentation;
